import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=31c3fae6&"
import script from "./AppLayout.vue?vue&type=script&lang=js&"
export * from "./AppLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Alert: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/core/Alert.vue').default,Header: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/blocks/Header.vue').default,Footer: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/blocks/Footer.vue').default})
